import axios from "axios";
import { config } from "../utils/conf";
import { requestHeaders } from "../utils/http";

export const fetchOrderInventory = (accessToken, queryParameters) => {
  const requestId = Date.now();
  return {
    type: "FETCH_ORDER_INVENTORY",
    meta: { queryParameters, requestId },
    payload: axios.get(`${config.inventoryApiUrl}/v1/order-inventories`, {
      headers: requestHeaders(accessToken),
      params: { ...queryParameters },
    }),
  };
};
